import { CSSProperties } from 'react';
import * as React from "react";
import { Link as RouterLink, LinkProps } from 'react-router-dom';

interface IProps extends LinkProps {
	className?: string;
}

const Link = (props: IProps) => {
	const { to, className } = props;

	const style: CSSProperties = {}
	if (to === '#') {
		style.color = 'red';
	}

	return (
		<RouterLink {...props} className={className} style={style}>
			{props.children}
		</RouterLink>
	);
};

export default Link;
